import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DatastoreBillingAgreementsModule,
  DatastoreCurrenciesIncludingExternalModule,
  DatastorePaymentShareMembersModule,
  DatastorePaymentShareMembersSpentAmountModule,
  DatastorePaymentShareTeamsModule,
  DatastoreUsersModule,
} from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { CreateInvitationModule } from 'app/invitation/create-invitation/create-invitation.module';
import { PaymentShareSetupCompleteComponent } from './payment-share-setup-complete/payment-share-setup-complete.component';
import { PaymentShareAddMemberInputComponent } from './payment-share-setup-members/payment-share-add-member-input/payment-share-add-member-input.component';
import { PaymentShareSetupMembersComponent } from './payment-share-setup-members/payment-share-setup-members.component';
import { PaymentShareSetupModalComponent } from './payment-share-setup-modal.component';
import { PaymentShareSetupNameComponent } from './payment-share-setup-name/payment-share-setup-name.component';
import { PaymentShareSetupSpendLimitComponent } from './payment-share-setup-spend-limit/payment-share-setup-spend-limit.component';
import { PaymentShareSpendLimitInputComponent } from '../payment-share/payment-share-spend-limit-input/payment-share-spend-limit-input.component';

@NgModule({
  imports: [
    UiModule,
    TrackingModule,
    CommonModule,
    CreateInvitationModule,
    DatastoreBillingAgreementsModule,
    DatastoreCurrenciesIncludingExternalModule,
    DatastorePaymentShareTeamsModule,
    DatastorePaymentShareMembersModule,
    DatastorePaymentShareMembersSpentAmountModule,
    DatastoreUsersModule,
  ],
  declarations: [
    PaymentShareAddMemberInputComponent,
    PaymentShareSetupModalComponent,
    PaymentShareSetupNameComponent,
    PaymentShareSetupSpendLimitComponent,
    PaymentShareSpendLimitInputComponent,
    PaymentShareSetupMembersComponent,
    PaymentShareSetupCompleteComponent,
  ],
})
export class PaymentShareSetupModalModule {}
